module.exports = __webpack_public_path__ + "static/media/user.85a73c5f.svg";